import api from '../../utils/api';
import * as AppActions from "./appActions";
import * as AuthActions from './authActions';
import {NotificationManager} from 'react-notifications';
import * as VideoActions from './videoActions';


export const ACTION_TEST_RETRIEVED = 'ACTION_TEST_RETRIEVED';
export const ACTION_TEST_SUBMITTED = 'ACTION_TEST_SUBMITTED';
export const ACTION_TEST_SCORE_RECEIVED = 'ACTION_TEST_SCORE_RECEIVED';
export const ACTION_TEST_UPDATING = 'ACTION_TEST_UPDATING';


function testRetrieved(test){
    return {
        type: ACTION_TEST_RETRIEVED,
        payload: test
    }
}

function testSubmitted(test){
    return {
        type: ACTION_TEST_SUBMITTED,
        payload: test
    }
}

function testScored(test){
    return {
        type: ACTION_TEST_SCORE_RECEIVED,
        payload: test
    }
}

function testUpdating(){
    return {
        type: ACTION_TEST_UPDATING
    }
}

export function requestTest(id, profileId, token){
    return (dispatch) => {
        api.getUserTestCopy(id, profileId, token, res => {
            //// console.log("Got test copy, pushing to ul");
            dispatch(VideoActions.gotDiagnosticUserLecture(res.data));
        })
    }
}


export function requestSubjectTest(id, profileId, token){
    return dispatch => {
        api.getSubjectTestCopy(id, profileId, token, res => {
            dispatch(VideoActions.gotUserLecture(res.data));
        })
    }
}
export function submitTest(test, token){
    return (dispatch) => {
        dispatch(testSubmitted(test));
        api.submitTest(test, token, res => {
            dispatch(testScored(test));
        })
    }
}

export function updateTest(test, token){
    return (dispatch) => {
        dispatch(testUpdating())
        api.updateUserTest(test, token, res => {
            dispatch(VideoActions.gotUserLecture(res.data));
        });

    }
}

export function updateSubjectTest(test, token){
    return (dispatch) => {
        dispatch(testUpdating())
        api.updateSubjectTest(test, token, res => {
            dispatch(VideoActions.gotUserLecture(res.data));
        });

    }
}


export function scoreTest(test, profileId, token){
    return (dispatch) => {
        //// console.log("score usert est");
        dispatch(testUpdating())
        api.updateUserTest(test, token, res => {
            api.scoreTest(res.data.id, token, result => {

                dispatch(VideoActions.gotDiagnosticUserLecture(result.data));
                dispatch(AuthActions.getProfile(profileId, token))
                dispatch(VideoActions.getCourseUser(profileId, token));
            })

        });

    }
}


export function scoreSubjectTest(test, profileId, token){
    return (dispatch) => {
        // console.log("Score subject test");
        dispatch(testUpdating())
        api.updateSubjectTest(test, token, res => {
            api.scoreSubjectTest(res.data.id, token, result => {
                dispatch(VideoActions.updatedUserLecture(result.data));
                dispatch(testRetrieved(result.data));
                dispatch(AuthActions.getProfile(profileId, token))
            })

        });

    }
}


// WEBPACK FOOTER //
// ./src/store/actions/testActions.js